<template>
  <div class="fields">
    <div class="fields__header">
      <div class="fields__title">
        <slot name="title" />
      </div>
      <div class="fields__title">
        <slot name="title-second" />
      </div>
    </div>
    <div class="fields__content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFields'
}
</script>

<style scoped lang="scss">
.fields {
  display: grid;
  gap: 8px;

  &__header {
    display: grid;
    grid-template-columns: minmax(0, 361px) 1fr;
    gap: 20px;
  }

  &__title {
    color: #333333;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.3;
  }

  &__content {
    display: grid;
    gap: 6px;
  }
}
</style>
